export default __webpack_public_path__ + "static/media/spa_white.a268ba1c.svg";